var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluetoothMed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "40px",
    viewBox: "0 -960 960 960",
    width: "40px",
    fill: "#405CB0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M445.07-87.18v-309.31L256-207.18 207.18-256l224-224-224-224L256-752.82l189.07 189.15v-309.15H480L700.82-652l-172 172 172 172L480-87.18h-34.93Zm69.86-476.49L603.18-652l-88.25-86.49v174.82Zm0 342L603.18-308l-88.25-88.49v174.82Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluetoothMed);
export default __webpack_public_path__ + "static/media/bluetooth-med.c475ef1551c38c7aad6d73e06d36916c.svg";
export { ForwardRef as ReactComponent };